import { isValueNullish } from "../../utils";

export function etagInterceptor($logger) {
	return {
		request: (config) => {
			if(config?.data?.ifMatch !== undefined) {
				if(config.headers === undefined) {
					config.headers = {};
				}
				config.headers["If-Match"] = config.data.ifMatch;
				delete config.data.ifMatch;
			}

			return config;
		},
		response: (response) => {
			if(Array.isArray(response?.data?.Data) || isValueNullish(response?.headers("etag")) || response?.data?.Data === undefined) {
				return response;
			}

			return {
				...response,
				data: {
					...response.data,
					Data: {
						...response.data.Data,
						etag: response.data.Data.etag ?? response.headers("etag")
					}
				}
			};
		}
	};
}